import type { Appearance } from "@circle-react/providers/Theme/themes/constants";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { useMemo } from "react";

import type { SpaceGroupWithSpaces } from "../../Sidebar";
import { EmptySpaceListAction } from "./EmptySpaceListAction";
import { SpaceListItem } from "./SpaceListItem";

export interface SpaceListProps {
  currentAppearance: Appearance;
  isAdmin: boolean;
  isLargeScreen: boolean;
  spaceGroup: SpaceGroupWithSpaces;
}

export const SpaceList = ({
  currentAppearance,
  isAdmin,
  isLargeScreen,
  spaceGroup,
}: SpaceListProps) => {
  const { spaces } = spaceGroup;

  const sortableItems = useMemo(
    () => spaces.map(space => `space-${space.id}`),
    [spaces],
  );

  if (spaces.length === 0) {
    return <EmptySpaceListAction spaceGroup={spaceGroup} />;
  }

  return (
    <SortableContext
      items={sortableItems}
      strategy={verticalListSortingStrategy}
    >
      <ul className="flex list-none flex-col gap-y-1">
        {spaces.map(space => (
          <li key={space.id}>
            <SpaceListItem
              currentAppearance={currentAppearance}
              isAdmin={isAdmin}
              isLargeScreen={isLargeScreen}
              space={space}
            />
          </li>
        ))}
      </ul>
    </SortableContext>
  );
};
